import { isBuffer } from 'util';
import { defaultRemoteSigningState } from './module-remotesigning-state';

export default {
	resetState(state) {
		Object.assign(state, defaultRemoteSigningState);
	},
	updateToView(state, res) {
		let isUpdate = true;
		if (state.lstCertConnect && state.lstCertConnect.length > 0) {
			state.lstCertConnect.forEach((dataItem) => {
				if (dataItem.KeyAlias == res.KeyAlias) {
					isUpdate = false;
				}
			});
			if (isUpdate) {
				state.lstCertConnect.push(res);
			}
		} else {
			state.lstCertConnect.push(res);
		}
	},
	setCertsConnect(state, res) {
		if (!res || res.length <= 0) {
			state.lstCertConnect = [];
		}
		
		state.lstCertConnect = res;
	},
	refreshData(state, res) {
		state.lstCertConnect = [];
		state.lstCertConnect.push(res);
	},
	removeConnectValue(state, res) {
		state.lstCertConnect.forEach((item) => {
			if (item.KeyAlias == res.KeyAlias) {
				state.lstCertConnect.remove(res);
			}
		});
	},
	updateLstConnectDefault(state, res) {
		state.lstCertConnect.forEach((item) => {
			item.IsDefault = false;
			if (item.KeyAlias == res.KeyAlias) {
				item.IsDefault = true;
			}
		});
	},
	setCompensCertLoading(state, value) {
		state.compensCertLoading = value;
	},
	setCompensCertStatus(state, value) {
		state.compensCertStatus = value;
	},
	setCompensCertStep(state, value) {
		state.compensCertStep = value;
	},
	setCompensCertData(state, value) {
		state.compensCertData = value;
	},
	setCompensCertLastShownDate(state, value) {
		state.compensCertLastShownDate = value;
	},
	setCompensCertList(state, value) {
		state.compensCertList = value || [];
	},
	setSelectedCompensCert(state, value) {
		state.selectedCompensCert = value;
	},
};
